( function () {
    'use strict';
    ( function ( $ ) {
        $('.insight-filter-wrap select').resizeselect();

        $(document).on('change','.insight-filter-wrap select',function(e){
            $('#insight-filter-form').submit();
        });
        /** code for load more */
        var canBeLoaded = true, // this param allows to initiate the AJAX call only if necessary
	    bottomOffset = 1500; // the distance (in px) from the page bottom when you want to load more posts
        var current_page = $('#current-page').val();

        $(document).on('submit','#insight-filter-form',function(e){
            e.preventDefault();

            var f_sector = $('#filter-sector').val();
            var f_type = $('#filter-type').val();
            var f_geo = $('#filter-geo').val();
            var data = [];
            data['fs'] = f_sector;
            data['ft'] = f_type;
            data['fg'] = f_geo;
            data['action'] = 'filter_insights';

            $.ajax({
                url : emerald_ajax_params.ajaxurl,
                dataType : 'json',
                data: $('#insight-filter-form').serialize(),
                type:'GET',
                beforeSend: function( xhr ){
                    $('.loader').addClass('active');
                    // you can also add your own preloader here
                    // you see, the AJAX call is in process, we shouldn't run it again until complete
                    canBeLoaded = true;
                    $('.insight-grid-container').html('');
                },
                success:function(response){
                    $('.insight-grid-container').html(response.content);
                    $('.loader').removeClass('active');
                    current_page = 1;
                    emerald_ajax_params.posts_q = response.posts;
                    //emerald_ajax_params.posts_q
                }
            });
        });

        $(window).scroll(function(){
            var data = {
                'action': 'loadmore_insights',
                'query': emerald_ajax_params.posts_q,
                'page' : current_page
            };

            if( $(document).scrollTop() > ( $(document).height() - bottomOffset ) && canBeLoaded == true ){
                $('.loader').addClass('active');
                $.ajax({
                    url : emerald_ajax_params.ajaxurl,
                    data:data,
                    type:'POST',
                    beforeSend: function( xhr ){
                        // you can also add your own preloader here
                        // you see, the AJAX call is in process, we shouldn't run it again until complete
                        canBeLoaded = false;
                    },
                    success:function(data){
                        if( data ) {
                            $('.insight-grid-container').find('article:last-of-type').after( data ); // where to insert posts
                            canBeLoaded = true; // the ajax is completed, now we can run it again
                            current_page++;
                        }
                        $('.loader').removeClass('active');
                    }
                });
            }
            return false;
        });
    } )( jQuery );
} )();
